export default __webpack_public_path__ + "static/media/userImg1.3403dbef.png";